import React, { useMemo } from 'react';

import * as S from './PromptTotalAttendance.style';

const PromptTotalAttendance = ({
	initAttendance,
	total,
	attendanceData,
	attendanceCount,
	absenceCount,
}) => {
	const attendance = useMemo(() => {
		if (attendanceCount !== undefined && absenceCount !== undefined) {
			return {
				...initAttendance,
				ATTENDANCE: {
					...initAttendance.ATTENDANCE,
					count: attendanceCount,
				},
				ABSENCE: {
					...initAttendance.ABSENCE,
					count: absenceCount,
				},
			};
		}

		if (!attendanceData) {
			return { ...initAttendance };
		}

		return attendanceData.reduce(
			(acc, obj) => {
				const type = obj?.state;
				if (!type) return acc;

				if (!acc[type]) {
					acc[type] = { ...initAttendance[type], count: 0 };
				}

				acc[type] = {
					...acc[type],
					count: (acc[type].count || 0) + 1,
				};
				return acc;
			},
			{ ...initAttendance },
		);
	}, [attendanceData, initAttendance, attendanceCount, absenceCount]);

	return (
		<S.Table>
			<thead></thead>
			<tbody>
				<tr>
					<th>총원</th>
					<td>{total}</td>
				</tr>
				{attendance &&
					Object.keys(attendance).map((key, index) => {
						return (
							<tr key={`${key}_${index}`}>
								<th>{attendance?.[key]?.name}</th>
								<td>{attendance?.[key]?.count || 0}</td>
							</tr>
						);
					})}
			</tbody>
		</S.Table>
	);
};

export default PromptTotalAttendance;
